import { useMutation } from "@tanstack/react-query";
import type {
  UpdateProjectFileInput,
  UpdateProjectFileResponseBody,
} from "@imagine/ai-service/shared-types/route-types";
import { saveArtifactFiles } from "@/lib/save-artifact-files";
import { getConsoleAuthToken } from "@/hooks/use-console-auth-token";
import { imagineStore } from "@/stores/imagine.store";

export function useSaveProjectFiles(projectId: string | null) {
  const refreshIframe = imagineStore.use.previewState.refreshIframe();

  return useMutation<
    UpdateProjectFileResponseBody,
    Error,
    Array<UpdateProjectFileInput>
  >({
    mutationFn: async (files) => {
      if (!projectId) {
        throw new Error("Missing project context");
      }
      if (!files.length) {
        throw new Error("No changes to commit");
      }
      const token = await getConsoleAuthToken();
      if (!token) {
        throw new Error("Not authenticated");
      }
      return saveArtifactFiles({ projectId, token, files });
    },
    onSuccess: (data) => {
      if (data.success) {
        refreshIframe();
      }
    },
  });
}
